import React, { useState, useEffect } from 'react';
import Output from './Output';
import { Input, Label, Tooltip } from 'reactstrap';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../../config';

const Upload = ({ value = null, onDelete, onChange, type, loading }) => {
  const [result, setResult] = useState(value);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [classNames, setClassNames] = useState({
    input: '',
    label: '',
  });

  useEffect(() => {
    if (loading) {
      setResult(null);
    }
  }, [loading]);

  const deleteItem = (deleteIndex) => {
    const nextState = result.filter((_, index) => index !== deleteIndex);
    setResult(nextState);
    onDelete?.(deleteIndex);
  };

  const handleFileLoad = (file, data, prevState, item) => {
    const realItem = {
      ...item,
      res: file,
    };
    data.push(realItem);

    if (prevState === null) {
      setResult(data);
    } else {
      setResult([...prevState, ...data]);
    }
  };

  const handleFileResult = (e) => {
    const { files } = e.target;
    handleInputStyles(e, true);

    setTooltipOpen(false);

    const data = [];
    const prevState = result;
    const filesArray = Array.from(files);

    filesArray.forEach((f) => {
      const FR = new FileReader();
      onChange?.(f);

      const item = {
        name: f.name,
        size: (f.size / 1024).toFixed(1),
        type: f.type,
        res: null,
      };

      FR.readAsBinaryString(f);
      FR.onloadend = () => {
        const FR_res = FR.result;
        handleFileLoad(FR_res, data, prevState, item);
      };
    });
  };

  const handleInputStyles = (e, reset) => {
    setClassNames({
      input: reset ? '' : 'hover_input',
      label: reset ? '' : 'hover_label',
    });
  };

  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };

  const { input: inputStyle, label: labelStyle } = classNames;

  return (
    <>
      <div className="upload_wrapper">
        {result && result.length > 0 && (
          <Output result={result} type={type} delete_item={deleteItem} />
        )}

        <div className="input_form" id="TooltipPayout">
          <SVG
            src={`${STATIC_PATH}/img/action-icons/clip-icon.svg`}
            height="21"
            width="21"
            cacheRequests
          />
          <Label
            htmlFor="input"
            className={labelStyle}
            onDragEnter={handleInputStyles}
            onDragLeave={(e) => handleInputStyles(e, true)}
            onDrop={(e) => handleInputStyles(e, true)}
          />
          <Input
            type="file"
            id="input"
            accept=".png, .jpg, .jpeg, .gif"
            name="uploads[]"
            className={inputStyle}
            onDragEnter={handleInputStyles}
            onDragLeave={(e) => handleInputStyles(e, true)}
            onDrop={(e) => handleInputStyles(e, true)}
            onChange={handleFileResult}
            onClick={(e) => e.stopPropagation()}
            multiple
          />
        </div>
      </div>
      <Tooltip
        className="ticket-tooltip"
        isOpen={tooltipOpen}
        placement="bottom"
        target="TooltipPayout"
        toggle={toggleTooltip}
      >
        Допустимые форматы файлов:
        &nbsp;&nbsp;.png,&nbsp;&nbsp;.jpg,&nbsp;&nbsp;.jpeg,&nbsp;&nbsp;.gif
      </Tooltip>
    </>
  );
};

export default Upload;
